import { createFeatureSelector } from '@ngrx/store';
import { SERVICING_SEATMAP_BACKUP_STORE_NAME, ServicingSeatmapBackupState } from './servicing-seatmap-backup.state';

/** Select ServicingSeatmapBackup State */
export const selectServicingSeatmapBackupState = createFeatureSelector<ServicingSeatmapBackupState>(
  SERVICING_SEATMAP_BACKUP_STORE_NAME
);